import React from "react";

/**
 * AuditIQ brand logo. Uses the customer-supplied PNG assets in /public/images.
 *  - On dark surfaces (sidebars, headers, login)  → white logo variant
 *  - On light surfaces                            → standard logo variant
 *  - `withWord` controls whether the descriptor tagline is shown
 */
export const BrandLogo = ({ size = 36, withWord = true, variant = "white" }) => {
  const src = variant === "white"
    ? "/images/auditiq-logo-white-medium.png"
    : "/images/auditiq-logo-medium.png";
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <img
        src={src}
        alt="AuditIQ"
        height={size}
        style={{ height: size, width: "auto", display: "block" }}
      />
      {withWord && (
        <div className="leading-tight hidden sm:block">
          <div className="text-[10px] tracking-[0.28em] text-steel uppercase">
            Govtech · Cyber · Infrastructure
          </div>
        </div>
      )}
    </div>
  );
};

export default BrandLogo;
